import React, { useEffect, useState, useMemo } from "react";
import SelectInput from "../ui/SelectInput";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { MdClose, MdDocumentScanner, MdOutlineWarning } from "react-icons/md";
import InputText from "../ui/InputText";
import Datepicker from "react-tailwindcss-datepicker";
import { FaCheckCircle, FaSpinner } from "react-icons/fa";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { toast } from "react-toastify";
import CheckBox from "../ui/components/CheckBox";
import { Button, CircularProgress } from "@mui/material";
import { FaDollarSign } from "react-icons/fa";


const AgregarServicio = ({ open, onClose, onSuccess, idCotizacion, planes, servicios, allServiciosCotizacionesList, setAllServiciosCotizacionesList, idCliente, moneda }) => {
  const minChars = 0;
  const [isLoading,setIsLoading] = useState(false);


  const [formValues, setFormValues] = useState({
    estado: "En espera",
    responsable: null,
    responsableName: "",
    codigo: "",
    servicio: null,
    planServicio: null,
    numeroItems: 1,
    fechaInicio: {
      startDate: null,
      endDate: null,
    },
    fechaFin: {
      startDate: null,
      endDate: null,
    },
    fechaRenovacion: {
      startDate: null,
      endDate: null,
    },
    fechaLanzamiento: {
      startDate: null,
      endDate: null,
    },
    igv: "no",
  });
  const [responsableServicio, setResponsableServicio] = useState(null);
  const [servicioQuery, setServicioQuery] = useState("");
  const [servicioOpen, setServicioOpen] = useState(false);
  const [allTrabajadoresList, setAllTrabajadoresList] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const [hydMode, setHydMode] = useState(false);

  const getTrabajadores = async () => {
    await axios
      .get(`${BACKEND}/api/trabajadores?limit=100`)
      .then(({ data }) => setAllTrabajadoresList(data.docs))
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    getTrabajadores();
  }, []);

  // Filtrar servicios: activos + el seleccionado si estuviera inactivo; búsqueda y categoría
  const filteredServicios = useMemo(() => {
    if (!servicios || servicios.length === 0) return [];
    const lowerQuery = (servicioQuery || "").toLowerCase();
    const selectedId = formValues.servicio?.id;
    return servicios
      .filter(
        (serv) =>
          (serv.active !== false || serv.id === selectedId) &&
          serv.categoria !== "Hosting y dominio" &&
          (lowerQuery === "" || serv.name?.toLowerCase().includes(lowerQuery))
      );
  }, [servicios, servicioQuery, formValues.servicio]);

  // Actualizar query cuando se selecciona un servicio
  useEffect(() => {
    if (formValues.servicio) {
      setServicioQuery(formValues.servicio.name || "");
    }
  }, [formValues.servicio]);

  const registerServicio = async (event) => {
    try {
      event.preventDefault();
      setIsError(false);

      if (
        //!formValues.responsable ||
        !formValues.fechaInicio ||
        !formValues.fechaFin ||
        !formValues.numeroItems ||
        !formValues.planServicio ||
        !formValues.servicio
      ) {
        toast.warning("Completa todos los campos");
        return;
      }

      setIsLoading(true);

      // First request
      const serviciosCotizacionesResponse = await axios.get(
        `${BACKEND}/api/serviciosCotizaciones?where[servicio][equals]=${
          formValues.servicio.id
        }&where[cotizacion.cliente][equals]=${idCliente}&where[estado][equals]=${"Terminado con exito"}&depth=0&limit=1000`
      );

      // Second request
      const response = await axios.post(
        `${BACKEND}/api/serviciosCotizaciones`,
        {
          cotizacion: idCotizacion,
          numeroRenovacion: serviciosCotizacionesResponse.data.docs.length,
          estado: "Por comenzar",
          responsable: formValues.responsable,
          subarea: formValues.servicio?.subarea || "",
          codigo: String(formValues.servicio?.id),
          servicio: formValues.servicio?.id,
          planServicio: formValues.planServicio,
          numeroItems: formValues.numeroItems,
          fechaInicio: formValues.fechaInicio.startDate,
          fechaFin: formValues.fechaFin.startDate,
          fechaLanzamiento: formValues.fechaLanzamiento.startDate,
          fechaRenovacion: formValues.fechaRenovacion.startDate,
          igv: formValues.igv,
        }
      );

      // Create satisfaction form  by defaulty
      const servicioFormSatisfaccion = await axios.get(
        `${BACKEND}/api/formularioServicio?where[servicio][equals]=${
          formValues.servicio.id
        }&where[tipo][equals]=satisfaccion&depth=0`
      );


      const servicioFormEntrada = await axios.get(
        `${BACKEND}/api/formularioServicio?where[servicio][equals]=${
          formValues.servicio.id
        }&where[tipo][equals]=entrada&depth=0`
      );


      if(servicioFormSatisfaccion?.data?.docs.length>0){
        await axios.post(
          `${BACKEND}/api/formularioServicioRespuestas`,
          {
            servicioCotizacion: formValues.servicio.id,
            formulario: servicioFormSatisfaccion.data.docs[0].id,
          }
        );
      }

      if( serviciosCotizacionesResponse.data.docs.length ===0){
        if(servicioFormSatisfaccion?.data?.docs.length>0){
          await axios.post(
            `${BACKEND}/api/formularioServicioRespuestas`,
            {
              servicioCotizacion: formValues.servicio.id,
              formulario: servicioFormEntrada.data.docs[0].id,
            }
          );
        }
      }

      // Update state with the result of the second request
      setAllServiciosCotizacionesList([
        ...allServiciosCotizacionesList,
        response.data.doc,
      ]);

      // Close modal
      onClose();

      // Reset form values
      setFormValues({
        estado: "Por comenzar",
        responsable: null,
        codigo: "",
        servicio: null,
        planServicio: null,
        numeroItems: 1,
        fechaInicio: {
          startDate: null,
          endDate: null,
        },
        fechaFin: {
          startDate: null,
          endDate: null,
        },
        fechaRenovacion: {
          startDate: null,
          endDate: null,
        },
        fechaLanzamiento: {
          startDate: null,
          endDate: null,
        },
        igv: "no",
      });
      setServicioQuery("");
      setServicioOpen(false);

      // Set success state
      setIsSuccess(true);
      setTimeout(() => setIsSuccess(false), 2000);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {open && (
        <form
          onSubmit={registerServicio}
          className="max-w-2xl mx-auto bg-gray-100 p-4 shadow-lg rounded-md my-6"
        >
          {/* Botón de cerrar */}
          <div className="flex justify-end">
            <div
              onClick={() => onClose()}
              className="cursor-pointer border border-gray-300 bg-gray-300 hover:bg-gray-400 transiton-all duration-100 p-2 rounded-md"
            >
              <MdClose className="text-black" />
            </div>
          </div>

          {/* Título */}
          <div className=" ">
            <h3 className="text-center text-sm font-bold">Nuevo Servicio</h3>
          </div>

          {/* Servicio */}
          <div className="py-3">
            <label className="block mb-2 text-xs font-medium text-gray-900">
              Servicio
            </label>
            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar servicio..."
                value={servicioQuery}
                onChange={(e) => {
                  setServicioQuery(e.target.value);
                  setServicioOpen(e.target.value.length >= minChars);
                  // Si el usuario está escribiendo y no coincide con el servicio seleccionado, limpiar selección
                  if (formValues.servicio && e.target.value !== formValues.servicio.name) {
                    setFormValues((prev) => ({
                      ...prev,
                      servicio: null,
                      responsable: null,
                      planServicio: null,
                    }));
                  }
                }}
                onFocus={() => setServicioOpen((servicioQuery || "").length >= minChars && filteredServicios.length > 0)}
                onBlur={() => setTimeout(() => setServicioOpen(false), 150)}
                className="w-full bg-white text-gray-700 p-2 rounded-md hover:bg-gray-50 border border-gray-400 text-xs pr-8"
              />
              {servicioQuery && (
                <button
                  type="button"
                  aria-label="Limpiar selección"
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setServicioQuery("");
                    setFormValues((prev) => ({
                      ...prev,
                      servicio: null,
                      responsable: null,
                      planServicio: null,
                    }));
                    setServicioOpen(false);
                  }}
                  title="Limpiar"
                >
                  ×
                </button>
              )}
              {servicioOpen && (servicioQuery || "").length >= minChars && filteredServicios.length > 0 && (
                <ul className="absolute z-50 bg-white shadow-lg border rounded-md mt-1 max-h-72 overflow-auto w-full text-sm shadow">
                  {filteredServicios.map((servicio) => (
                    <li
                      key={servicio.id}
                      className="px-3 text-xs text-gray-900 py-2 hover:bg-gray-100 cursor-pointer"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        setFormValues((prev) => ({
                          ...prev,
                          servicio: servicio,
                          responsable: servicio?.encargado ? servicio?.encargado?.id : null,
                        }));
                        setServicioQuery(servicio.name);
                        setServicioOpen(false);
                      }}
                      title={servicio.name}
                    >
                      {servicio.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          {/* Plan */}
          {formValues.servicio && 
            <SelectInput
              title={"Plan"}
              value={formValues.planServicio}
              options={formValues.servicio.preciosUnitarios.map((e) => {
                return { id: e.id, label: e?.plan?.name, value: e.plan?.id };
              })}
              placeholder={"Plan"}
              setValue={(e) =>
                setFormValues((prev) => ({ ...prev, planServicio: e }))
              }
            />
          }

          {/* Cantidad */}
          <InputText
            title={"Cantidad"}
            value={formValues.numeroItems}
            setValue={(e) =>
              setFormValues((prev) => ({ ...prev, numeroItems: e }))
            }
          />

          {/* Fecha de inicio */}
          <div className="mt-6">
            <div>
              <label
                htmlFor={"fechaInicio"}
                class="block mb-1 text-xs font-medium text-gray-900 "
              >
                Fecha de inicio
              </label>
              <input 
                type="date"
                placeholder="Fecha límite"
                value={formValues.fechaInicio?.startDate || ''} // Manejo de valores nulos/undefined
                className="bg-gray-50 py-2 px-4 border border-gray-300 focus:outline-none w-full rounded-md text-xs"
                onChange={(e) => 
                  setFormValues((prev) => ({
                    ...prev,
                    fechaInicio: {
                      ...prev.fechaInicio,
                      startDate: e.target.value,
                      endDate: e.target.value,
                    },
                  }))
                }
              />
            </div>
          </div>

          {/* Fecha de finalización */}
          <div className="mt-6">
            <div>
              <label
                htmlFor={"fechaFin"}
                class="block mb-1 text-xs font-medium text-gray-900 "
              >
                Fecha de finalización
              </label>
              <input 
                type="date"
                placeholder="Fecha límite"
                value={formValues.fechaFin?.startDate || ''} // Manejo de valores nulos/undefined
                className="bg-gray-50 py-2 px-4 border border-gray-300 focus:outline-none w-full rounded-md text-xs"
                onChange={(e) => 
                  setFormValues((prev) => ({
                    ...prev,
                    fechaFin: {
                      ...prev.fechaFin,
                      startDate: e.target.value,
                      endDate: e.target.value,
                    },
                  }))
                }
              />
            </div>
          </div>

          {/* Total */}
          {/* {formValues.servicio && formValues.planServicio && (
            <div className=" flex justify-end ">
              <div>
                <span className=" text-gray-500 text-xs">Total</span> :{" "}
                <span className=" text-gray-700 text-xs font-semibold">
                  {moneda}{" "}
                  {servicios
                    .find((e) => e.id === formValues.servicio?.id)
                    .preciosUnitarios.find(
                      (ev2) => ev2.plan.id === formValues.planServicio
                    )?.precio * formValues.numeroItems}
                </span>
              </div>
            </div>
          )} */}

          {/* Botón de registrar */}
          <div className=" my-6 flex justify-center">

            <Button
              variant="contained"
              type="submit"
              disabled={isLoading}
              endIcon={isLoading ? <CircularProgress size={14} className="animate-spin" /> : <FaDollarSign size={14} />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins", 
                padding: "8px 24px",
                backgroundColor: "#2563eb",
                textTransform: "none",
                borderRadius: "8px",
                width: "180px",
                '&:hover': {
                  backgroundColor: "#1d4ed8",
                }
              }}
            >
              Registrar
            </Button>
          </div>
        </form>
      )}

      <div className=" my-3 flex justify-center">
        {isSuccess && (
          <div className=" bg-green-50 text-green-600 shadow-md p-2 rounded-md inline-flex justify-center gap-4 items-center">
            Registrado <FaCheckCircle />
          </div>
        )}
        {isError && (
          <div className=" bg-red-50 text-red-600 shadow-md p-2 rounded-md inline-flex justify-center gap-4 items-center">
            Error al registrar <MdOutlineWarning />
          </div>
        )}
      </div>
    </div>
  );
};

export default AgregarServicio;
